@if (isOffline) {
  <div class="p-4">
    <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='adminOfflineMessage'></ebs-offline-message>
  </div>
}

@if (!isOffline) {
  <div class="course-admin-wrapper main-content scrollable full-height-minus-header">
    <div class="scrollbar">
      @if (!isLoading) {
        <div class="card">
          <div class="col-12 col-xl-8 offset-xl-2">
            @if (isSynching) {
              <ebs-spinner [spinnerMessage]="spinnerMessage" [boxPadding]="'15px'"></ebs-spinner>
            }
            @if (!isSynching) {
              <div class="p-2">
                @for (message of notificationMessages; track message) {
                  <div class="float-left">
                    {{message}}
                  </div>
                }
                <span class="float-right">
                  <a href="/system-notifications">Go to notifications <i class="fas fa-chevron-circle-right fa-lg"></i></a>
                </span>
              </div>
            }
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr class="header-row">
                    <th>Code</th>
                    <th>Course name</th>
                    <th><span class="float-right">Action</span></th>
                  </tr>
                </thead>
                <tbody>
                  @for (course of courseList; track course) {
                    <tr class="body-row">
                      <td>{{course.courseCode}}</td>
                      <td>{{course.courseName}}</td>
                      <td>
                        <button (click)="cacheCourse(course)" type="button" [disabled]="isSynching"
                        class="btn btn-primary btn-sm float-right" >Sync now</button>
                        <button type="button" (click)="viewLogos(course.courseCode, course.courseName)"
                        class="btn btn-primary btn-sm float-right btn-logos" >Logos</button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            @if (cacheSuccess) {
              <div class="alert alert-success">The cache job has successfully started</div>
            }
            @if (!cacheSuccess && !isSynching && hasFailed) {
              <div class="alert alert-danger">Error updating cache</div>
            }
          </div>
        </div>
      }
    </div>
  </div>
}